import { render, staticRenderFns } from "./Card.vue?vue&type=template&id=56fea9e4&scoped=true&"
import script from "./Card.vue?vue&type=script&lang=js&"
export * from "./Card.vue?vue&type=script&lang=js&"
import style0 from "./Card.vue?vue&type=style&index=0&id=56fea9e4&lang=less&scoped=true&"
import style1 from "./Card.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56fea9e4",
  null
  
)

export default component.exports